export enum CardLayoutEnum {
  Vertical = 'vertical',
  Horizontal = 'horizontal',
}
